export const actions = {
  UPDATE_VALUE: 'INPUT::UPDATE_VALUE',
};

export function updateValue(
  inputHandle,
  inputValue,
  questionHandle,
  stepHandle
) {
  return {
    type: actions.UPDATE_VALUE,
    payload: {
      stepHandle,
      questionHandle,
      inputHandle,
      value: inputValue,
    },
  };
}
